import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  chooseCourses,
  chooseInsurance,
  chooseNote,
  chooseStudent,
  chooseVisa,
  clearProposal,
  removingCourses,
  removingInsurance,
  removingNote,
  // removingPayment,
  removingStudent,
  removingVisa,
  updateProposal,
} from "../../actions/proposal";
import { images } from "../../constants";
import ItemCourseInProposal from "../Course/ItemCourseInProposal";
import AlertPopUp from "../generalComponents/AlertPopUp";
import LoaderDots from "../generalComponents/LoaderDots";
import { useCountSum } from "../hooks/useCountSum";
import ModalProposal from "../Modals/ModalProposal";
import DescriptionCard from "../Proposals/DescriptionCard";
import ProposalCoursesSelect from "../Proposals/ProposalCoursesSelect";
import ProposalCreatedEditModal from "../Proposals/ProposalCreatedEditModal";
import ProposalInsuranceSelect from "../Proposals/ProposalInsuranceSelect";
import ProposalNoteSelected from "../Proposals/ProposalNoteSelected";
import ProposalStudentSelect from "../Proposals/ProposalStudentSelect";
import ProposalVisaSelect from "../Proposals/ProposalVisaSelect";
import StudentProposal from "../Student/StudentProposal";
import InsuranceCard from "../visa-insurance/InsuranceCard";
import VisaCard from "../visa-insurance/VisaCard";
import "./ProposalForm.scss";
const ProposalFormEditing = () => {
  const [messageError, setMessageError] = useState(null);


  const proposalToUpdate = useSelector(
    (state) => state.proposals.proposalToUpdate
  );


  const proposalUpdated = useSelector(
    (state) => state.proposals.proposalUpdated
  );


  const addingStudent = useSelector((state) => state.proposals.addingStudent);
  const studentSelected = useSelector(
    (state) => state.proposals.studentselected
  );

  const addingCourses = useSelector((state) => state.proposals.addingCourses);
  const coursesSelected = useSelector(
    (state) => state.proposals.coursesSelected
  );

  const addingVisa = useSelector((state) => state.proposals.addingVisa);
  const visaSelected = useSelector((state) => state.proposals.visa);

  const addingInsurance = useSelector(
    (state) => state.proposals.addingInsurance
  );
  const insuranceSelected = useSelector((state) => state.proposals.insurance);

  const addingNote = useSelector((state) => state.proposals.addingNote);
  const noteSelected = useSelector((state) => state.proposals.note);


  const { loading, modalOpen } = useSelector((state) => state.ui);

  const dispatch = useDispatch();

  //custom hooks

  const courseCount = useCountSum(coursesSelected);
  const visaCount = useCountSum(visaSelected);
  const insuranceCount = useCountSum(insuranceSelected);

  useEffect(() => {
    if (messageError) {
      setTimeout(() => {
        setMessageError(null);
      }, [2000]);
    }
  }, [messageError]);

  //handlers click
  const handleClickStudent = () => {
    dispatch(chooseStudent());
  };
  const handleClickCourses = () => {
    dispatch(chooseCourses());
  };
  const handleClickVisa = () => {
    dispatch(chooseVisa());
  };
  const handleClickInsurance = () => {
    dispatch(chooseInsurance());
  };
  const handleClicNote = () => {
    dispatch(chooseNote());
  };



  const handleClickProposal = () => {
    const proposalData = {
      ...proposalToUpdate,
      studentSelected,
      coursesSelected,
      visaSelected,
      insuranceSelected,
      noteSelected,
    };

    if (!studentSelected) {
      setMessageError({ msg: `User not added` });
      return;
    }
    if (coursesSelected.length === 0) {
      setMessageError({ msg: "Courses not added!" });
      return;
    }
    if (!visaSelected) {
      setMessageError({ msg: "Visa not added!" });
      return;
    }
    if (!insuranceSelected) {
      setMessageError({ msg: "Insurance not added!" });
      return;
    }
    if (!noteSelected) {
      setMessageError({ msg: "Note not added!" });
      return;
    }

   
    dispatch(updateProposal(proposalData));

  };

  if (!proposalToUpdate) {
    return (
      <div className="proposalForm__alert">
        <div className="proposalForm__alert--wrapper">
          <AlertPopUp msg={`Proposal for Editing not found`} type={400} />
          <button className="btn-primary">
            <NavLink to={`/creator/proposals/section-proposal`}>
              Go Back
            </NavLink>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app__proposalForm">
      <div className="proposalForm__heading">
        <h2 className="text-title">Edit Proposal</h2>
      </div>
      {/* Choose Student */}
      <div className="proposalForm__section--choose-student sub-section">
        <div className="section__heading">
          <div className="section__heading--title">
            <img src={images.IconProfileR} alt="" />
            <h2 className="title-gray-black-18">Choose a Student</h2>
          </div>
          <button className="btn-primary" onClick={handleClickStudent}>
            {studentSelected ? (
              <img src={images.IconChange} alt="icon-change" />
            ) : (
              "+ add"
            )}
          </button>
        </div>

        <div className="choose-student__content">
          {studentSelected && (
            <StudentProposal studentSelected={studentSelected} />
          )}
        </div>
      </div>

      {/* Choose Course */}

      <div className="proposalForm__section--choose-course sub-section">
        <div className="section__heading">
          <div className="section__heading--title">
            <img src={images.IconCourseR} alt="" />
            <h2 className="title-gray-black-18">Choose Courses</h2>
          </div>

          <button className="btn-primary" onClick={handleClickCourses}>
            + add
          </button>
        </div>
        <div className="choose-course__content">
          {coursesSelected?.map((course) => (
            <ItemCourseInProposal key={course._id} course={course} />
          ))}
        </div>

        {coursesSelected.length !== 0 && (
          <div className="choose-course__total-sum">
            <div className="title-gray-bold-16">
              <span>Total: </span>
              <span>${courseCount.countResul}</span>
            </div>
          </div>
        )}
      </div>

      <div className="proposalForm__section--choose-visa sub-section">
        <div className="section__heading">
          <div className="section__heading--title">
            <img src={images.IconVisa} alt="" />
            <h2 className="title-gray-black-18">Choose Visa</h2>
          </div>

          <button className="btn-primary" onClick={handleClickVisa}>
            + add
          </button>
        </div>
        <div className="choose-visa__content">
          {/* {visaSelected && <VisaCard visaSelected={visaSelected} />} */}
          {visaSelected?.map((visa) => (
            <VisaCard key={visa._id} visaSelected={visa} />
          ))}
        </div>
        {visaSelected.length !== 0 && (
          <div className="sum-section">
            <div className="title-gray-bold-16">
              <span>Total: </span>
              <span>${visaCount.countResul}</span>
            </div>
          </div>
        )}
      </div>

      <div className="proposalForm__section--choose-insurance sub-section">
        <div className="section__heading">
          <div className="section__heading--title">
            <img src={images.IconInsurance} alt="" />
            <h2 className="title-gray-black-18">Choose Insurance</h2>
          </div>

          <button className="btn-primary" onClick={handleClickInsurance}>
            + add
          </button>
        </div>
        <div className="choose-insurance__content">
          {insuranceSelected?.map((insurance, index) => (
            <InsuranceCard key={insurance._id} insurance={insurance} />
          ))}
        </div>
        {insuranceSelected.length !== 0 && (
          <div className="sum-section">
            <div className="title-gray-bold-16">
              <span>Total: </span>
              <span>{insuranceCount.countResul}</span>
            </div>
          </div>
        )}
      </div>

      <div className="proposalForm__section--add-note sub-section">
        <div className="section__heading">
          <div className="section__heading--title">
            <img src={images.IconInsurance} alt="" />
            <h2 className="title-gray-black-18">Add a Note</h2>
          </div>

          <button className="btn-primary" onClick={handleClicNote}>
            + add
          </button>
        </div>
        <div className="choose-insurance__content">
          {noteSelected && <DescriptionCard note={noteSelected} />}
        </div>
      </div>

      {/* <div className="proposalForm__section--payments sub-section">
        <div className="section__heading">
          <div className="section__heading--title">
            <img src={images.IconPayment} alt="" />
            <h2 className="title-gray-black-18">Set Payments</h2>
          </div>

          <button className="btn-primary" onClick={handleClickPayment}>
            + add
          </button>
        </div>
        <div className="Payments__content">
          {paymentSelected && (
            <>
              <div>
                <div>
                  <h2>First payment</h2>
                  <p>{paymentSelected.minpayment}</p>
                </div>
                <div>
                  <h2>Date payment</h2>
                  <p>{paymentSelected.datepayment}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div> */}

      <div className="proposalForm__section--button">
        {loading ? (
          <LoaderDots />
        ) : (
          <button className="btn-create" onClick={handleClickProposal}>
            Edit Proposal
          </button>
        )}

        {messageError && (
          <p className="error-message-form">{messageError.msg}</p>
        )}
      </div>

      {/* MODALS */}

      {modalOpen && addingStudent && (
        <ModalProposal clean={removingStudent}>
          <ProposalStudentSelect />
        </ModalProposal>
      )}

      {modalOpen && addingCourses && (
        <ModalProposal clean={removingCourses}>
          <ProposalCoursesSelect />
        </ModalProposal>
      )}

      {modalOpen && addingVisa && (
        <ModalProposal clean={removingVisa}>
          <ProposalVisaSelect />
        </ModalProposal>
      )}

      {modalOpen && addingInsurance && (
        <ModalProposal clean={removingInsurance}>
          <ProposalInsuranceSelect />
        </ModalProposal>
      )}

      {modalOpen && addingNote && (
        <ModalProposal clean={removingNote}>
          <ProposalNoteSelected />
        </ModalProposal>
      )}

      {modalOpen && proposalUpdated && (
        <ModalProposal clean={clearProposal}>
          {/* <ProposalCreatedModal /> */}

          <ProposalCreatedEditModal proposal={proposalUpdated} />
        </ModalProposal>
      )}
    </div>
  );
};

export default ProposalFormEditing;
